var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
import InputKeyBoard from '../input-key-board';
function normalizeValue(value, maxLength) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    if (maxLength && value && value.length > maxLength) {
        value = value.slice(0, maxLength);
    }
    return value + '';
}
class InputItem extends React.Component {
    constructor(props) {
        super(props);
        this.popInputRef = (el) => {
            const { autoFocus, inputRef } = this.props;
            this.myRef = el;
            if (inputRef) {
                inputRef(el);
            }
            !!autoFocus && this.focus();
        };
        this.focus = () => {
            if (this.myRef) {
                this.myRef.focus();
            }
        };
        this.blur = () => {
            if (this.myRef) {
                this.myRef.blur();
            }
        };
        this.onInputChange = (eventOrVal) => {
            const value = typeof eventOrVal === 'string' ? eventOrVal : normalizeValue(eventOrVal.target.value || '', this.props.maxLength);
            this.setState({
                value: value,
            });
            const { onChange } = this.props;
            onChange && onChange(value);
        };
        this.onInputFocus = (eventOrVal) => {
            const value = typeof eventOrVal === 'string' ? eventOrVal : normalizeValue(eventOrVal.target.value || '');
            const { onFocus } = this.props;
            onFocus && onFocus(value);
            this.setState({
                isFocus: true,
            });
        };
        this.onInputBlur = (eventOrVal) => {
            const value = typeof eventOrVal === 'string' ? eventOrVal : normalizeValue(eventOrVal.target.value || '');
            const { onBlur } = this.props;
            onBlur && onBlur(value);
            this.setState({
                isFocus: false,
            });
        };
        this.onInputClear = () => {
            this.setState({
                value: '',
            });
            const { onChange } = this.props;
            onChange && onChange('');
        };
        this.state = {
            value: normalizeValue(props.value || props.defaultValue),
            isFocus: false,
        };
    }
    static getDerivedStateFromProps(nextProps, preState) {
        if (nextProps.value !== undefined) {
            return {
                value: normalizeValue(nextProps.value),
                isFocus: preState.isFocus,
            };
        }
        return null;
    }
    render() {
        const _a = this.props, { placeholder, togglePlaceholder, errorMsg, label, extra, type, style, maxLength, disabled, className, clearable, customKeyBoard, onVirtualKeyboardConfirm, keyboardAlign, keyboardWrapProps, keyboardHeader } = _a, restProps = __rest(_a, ["placeholder", "togglePlaceholder", "errorMsg", "label", "extra", "type", "style", "maxLength", "disabled", "className", "clearable", "customKeyBoard", "onVirtualKeyboardConfirm", "keyboardAlign", "keyboardWrapProps", "keyboardHeader"]);
        const { value, isFocus } = this.state;
        const inputItemCls = classnames('cfm_input_item', {
            'cfm_input_item_focus': isFocus,
            'cfm_input_item_error': errorMsg,
            'cfm_input_item_disabled': disabled,
            'cfm_input_item_toggle': togglePlaceholder,
        }, className);
        const placeholderCls = classnames('cfm_input_item_placeholder', {
            'cfm_input_item_placeholder_left': !label,
            'cfm_input_item_top': value,
        });
        return (<div className={inputItemCls}>
        <div className='cfm_input_item_warp'>
          {label ? <div className='cfm_input_item_label'>{label}</div> : null}
          <div onClick={this.focus} className='cfm_input_item_control'>
            {customKeyBoard
            ? <InputKeyBoard ref={el => (this.myRef = el)} {...restProps} value={normalizeValue(value)} type={type} maxLength={maxLength} placeholder={placeholder} onChange={this.onInputChange} onFocus={this.onInputFocus} onBlur={this.onInputBlur} onVirtualKeyboardConfirm={onVirtualKeyboardConfirm} disabled={disabled} style={style} keyboardAlign={keyboardAlign} keyboardWrapProps={keyboardWrapProps} keyboardHeader={keyboardHeader}/>
            : <input ref={this.popInputRef} pattern={type === 'number' ? '[0-9]*' : undefined} {...restProps} className='cfm_input_item_inner' value={normalizeValue(value)} placeholder={togglePlaceholder ? '' : placeholder} onChange={this.onInputChange} defaultValue={undefined} style={style} type={type} maxLength={maxLength} onFocus={this.onInputFocus} onBlur={this.onInputBlur} disabled={disabled}/>}
            {togglePlaceholder && !customKeyBoard ? <div className={placeholderCls}>{placeholder}</div> : null}
          </div>
          {clearable && !!value && !disabled ? <div className='cfm_input_item_clear' onClick={this.onInputClear}><Icon size='sm' type='close_2'/></div> : null}
          {extra ? <div className='cfm_input_item_extra'>{extra}</div> : null}
        </div>
        {errorMsg ? <div className='cfm_input_item_error_tips'>{errorMsg}</div> : null}
      </div>);
    }
}
InputItem.defaultProps = {
    togglePlaceholder: false,
    defaultValue: '',
    errorMsg: '',
    clearable: true,
    customKeyBoard: false,
    autoFocus: false,
};
export default InputItem;



// WEBPACK FOOTER //
// ./components/input-item/index.tsx